import React from "react";
import { Badge } from "@/components/ui/badge";

/**
 * getInvoiceTypeBadge - Returns a styled badge for invoice type
 * 
 * @param invoiceType - The type of invoice ('full', 'partial', 'percentage', 'custom_amount')
 * @param percentage - Optional percentage value for percentage-based invoices
 * @returns Badge component or null if no type
 */
export const getInvoiceTypeBadge = (
  invoiceType: string | null | undefined,
  percentage?: number | null
): React.ReactNode => {
  switch (invoiceType) {
    case 'full':
      return <Badge variant="default">Full</Badge>;
    case 'partial':
      return <Badge variant="secondary">Partial</Badge>;
    case 'percentage':
      return <Badge variant="outline">{percentage}%</Badge>;
    case 'custom_amount':
      return <Badge variant="outline">Custom</Badge>;
    case 'standalone':
      return <Badge variant="secondary">Standalone</Badge>;
    default:
      return null;
  }
};
